import axios from '../axios'

/* 
 * 题库管理
 */
//查询
export const getListApi = (params) => {
  return axios({
      url: '/exam/list',
      method: 'get',
      params
  })
}
// 新增试卷
export const addApi = data => {
    return axios({
        url: '/exam',
        method: 'post',
        data
    })
}
//更新试卷
export const updateApi = data => {
  return axios({
      url: '/exam',
      method: 'put',
      data
  })
}
//查详情
export const detailApi= (id) => {
  return axios({
      url: `/exam/${id}`,
      method: 'get',
      // params
  })
}
//删除试卷
export const deleteApi= (id) => {
  return axios({
      url: `/exam/${id}`,
      method: 'delete',
      // params
  })
}
//批量删除试卷
export const deleteBatchApi= (ids) => {
  return axios({
      url: `/exam/batch/${ids}`,
      method: 'delete',
      // params
  })
}

//、、、、、、、、、、试题、、、、、、、、、、、、、、、、、、、
//根据试卷id 查询试题
export const getQuetionByExamIdListApi = (params) => {
  return axios({
      url: `/exam/item/list/`,
      method: 'get',
      params
  })
}

// 新增题目
export const addQuestionApi = data => {
  return axios({
      url: '/exam/item',
      method: 'post',
      data
  })
}
// 批量新增题目
export const addBatchQuestionApi = data => {
  return axios({
      url: '/exam/item/batch',
      method: 'post',
      data
  })
}
// 批量新增题目
export const editBatchQuestionApi = data => {
  return axios({
      url: '/exam/item/batch',
      method: 'put',
      data
  })
}
//更新题目
export const updateQuestionApi = data => {
  return axios({
      url: '/exam/item',
      method: 'put',
      data
  })
}
//导入
export const improtApi = data => {
  return axios({
      url: '/exam/item/import',
      method: 'post',
      data
  })
}
//删除试卷
export const deleteTopicApi= (id) => {
  return axios({
      url: `/exam/item/${id}`,
      method: 'delete',
      // params
  })
}
//批量删除试卷
export const deleteBatchTopicApi= (ids) => {
  return axios({
      url: `/exam/item/batch/${ids}`,
      method: 'delete',
      // params
  })
}

// 章节 
//查询列表
export const getChapterListApi = (params) => {
  return axios({
      url: `/exam/chapter/section/list`,
      method: 'get',
      params
  })
}

//清空
export const emptyListApi = (params) => {
  return axios({
      url: `/exam/item/clear`,
      method: 'delete',
      params
  })
}


// WEBPACK FOOTER //
// ./src/http/api/questionBank.js